import type { ReactNode } from "react";

interface EmptyStateProps {
  icon: ReactNode;
  title: string;
  description: ReactNode;
}

export function EmptyState({ icon, title, description }: EmptyStateProps) {
  return (
    <div className="flex min-h-[50vh] flex-col items-center justify-center text-center pointer-events-none">
      <div className="flex justify-center mb-4">{icon}</div>
      <h2 className="text-2xl font-bold text-foreground mb-3">{title}</h2>
      <p className="text-text-secondary max-w-md mx-auto">{description}</p>
    </div>
  );
}
